export default __webpack_public_path__ + "static/media/labor_contract.eea54862.svg";